import React from 'react';

import Button from '@mui/material/Button';


const Submit = React.forwardRef((props, ref) => {
  const { submitting = false, children = 'Submit', ...restProps } = props;
  return (
    <Button
      ref={ref}
      type="submit"
      loading={submitting}
      {...restProps}
    >
      {children}
    </Button>
  );
});

Submit.displayName = 'Submit';
export default Submit;
